import { createContext, ReactNode, useContext, useState } from "react"
import ReactModal from "react-modal"
import { Spin } from "@gogoro/go-design"

interface LoadingContextProps {
  isOpen: boolean
  setIsOpen: (value: boolean) => void
}

const LoadingContext = createContext<LoadingContextProps | null>(null)

export const LoadingProvider = ({ children }: { children: ReactNode }) => {
  const [isOpen, setIsOpen] = useState(false)

  const value = {
    isOpen,
    setIsOpen,
  }

  return (
    <LoadingContext.Provider value={value}>
      {children}
      <ReactModal
        isOpen={isOpen}
        style={{
          overlay: {
            background: "rgb(0, 0, 0, 0.4)",
          },
          content: {
            background: "initial",
            border: "none",
            inset: "50% 0px 0px 50%",
            transform: "translate(-50%, -50%)",
            width: "fit-content",
            height: "fit-content",
            overflow: "unset",
          },
        }}>
        <Spin show={isOpen} />
      </ReactModal>
    </LoadingContext.Provider>
  )
}

export const useLoading = () => {
  const { setIsOpen = () => {} } = useContext(LoadingContext) || {}

  const withLoading =
    (fn: Function) =>
    (...args: any) => {
      return new Promise((resolove) => {
        resolove(setIsOpen(true))
      })
        .then(() => {
          return fn(...args)
        })
        .finally(() => {
          setIsOpen(false)
        })
    }

  const blockUI = () => {
    setIsOpen && setIsOpen(true)
  }
  const unBlockUI = () => setIsOpen(false)

  return { withLoading, blockUI, unBlockUI }
}
